import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { auth, sendPasswordReset,  } from "../../firebase";
import styled from "styled-components";

const ResetWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #009D63;
    height: 100vh;
`

const ResetContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    border-radius: 4px;
    padding: 20px;
    width: 300px;
    height: 300px;
`

const ResetTextBox = styled.input`
    border: 1px solid #009D63;
    border-radius: 4px;
    padding: 10px;
    margin: 10px;
    width: 200px;
`
const ResetButton = styled.button`
    border: 1px solid #009D63;
    border-radius: 4px;
    padding: 10px;
    margin: 10px;
    width: 200px;
    background: #009D63;
    color: #ffffff;
    font-weight: 600;
`


const Reset = () => {
  const [email, setEmail] = useState("");
  const [user, loading, error] = useAuthState(auth);
  const navigate = useNavigate();
  useEffect(() => {
    if (loading) return;
    if (user) navigate("/dashboard");
  }, [user, loading]);
  return (
    <ResetWrapper>
      <ResetContainer>
        <ResetTextBox
          type="text"
          className="reset__textBox"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="E-mail Address"
        />
        <ResetButton
          className="reset__btn"
          onClick={() => sendPasswordReset(email)}
        >
          Send password reset email
        </ResetButton>
        <div>
          Don't have an account? <Link to="/register">Register</Link> now.
        </div>
      </ResetContainer>
    </ResetWrapper>
  );
}
export default Reset;